var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.statusShip == 4)?_c('div',[_c('h1',[_vm._v("statusShip")]),_vm._v(" "+_vm._s(_vm.item.user_btn_prepeared)+" "+_vm._s(_vm.item.user_btn_delivered)+" "+_vm._s(_vm.item.user_btn_in_transit)+" "),(
      _vm.item.user_btn_prepeared != null ||
      _vm.item.user_btn_delivered != null ||
      _vm.item.user_btn_in_transit != null
    )?_c('move-toltip-component',{attrs:{"order":_vm.order}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }